"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var axios_1 = __importDefault(require("axios"));
var api_1 = require("api");
var use_stores_1 = require("hooks/use-stores");
var utils_1 = require("../../util/utils");
var PrefsStore_1 = require("../../stores/PrefsStore");
var GanttChartGrid = mobx_react_1.observer(function (_a) {
    var currentDate = _a.currentDate, grabbing = _a.grabbing;
    var prefsStore = use_stores_1.useStores().prefsStore;
    react_1.useEffect(function () {
        if (prefsStore.data.bankHolidays === null) {
            axios_1.default.get('https://www.gov.uk/bank-holidays.json')
                .then(function (response) {
                prefsStore.editData({
                    bankHolidays: response.data
                });
            })
                .catch(api_1.catchHandler);
        }
    }, []);
    var createDays = function () {
        var range = utils_1.dateRange(currentDate);
        var weekArray = [];
        for (var week = 0; week < range.end.diff(range.start, 'w'); week++) {
            var dayArray = [];
            for (var day = 0; day < 7; day++) {
                var dayData = range.start.add(week, 'w').add(day, 'd').startOf('d');
                var disabled = day === 0 || day === 6;
                var bhSetting = PrefsStore_1.BankHolidayDivisions.ENGLAND_AND_WALES;
                var bankHolidays = prefsStore.data.bankHolidays;
                if (bankHolidays) {
                    for (var _i = 0, _a = bankHolidays[bhSetting].events; _i < _a.length; _i++) {
                        var event_1 = _a[_i];
                        if (dayData.isSame(event_1.date, 'date')) {
                            disabled = true;
                        }
                    }
                }
                dayArray.push(react_1.default.createElement("div", { className: 'gantt-chart-grid__day', "data-disabled": disabled, "data-current": utils_1.checkCurrentDay(dayData), "data-date": dayData.format(), key: "gcg_" + week.valueOf() + "_" + day }, "\u00A0"));
            }
            weekArray.push(react_1.default.createElement("div", { className: 'gantt-chart-grid__week flex flex-row', key: "gcg_" + week.valueOf() }, dayArray));
        }
        return weekArray;
    };
    return (react_1.default.createElement("div", { className: 'gantt-chart-grid flex flex-row', "data-grabbing": grabbing }, createDays()));
});
exports.default = GanttChartGrid;
